import { ErrorResponse } from 'services/apiGatewayClient/client';
import i18next from 'i18next';

/**
 * @deprecated - see https://bit.ly/3olCH4J for more details.
 *
 *
 * This function supports the format returned by our legacy API Gateway
 * endpoints. It also falls back to the generic errorMessage that's been in
 * MySaleCycle since the beginning when it was still called rules-engine-ui.
 *
 * NOTE: This function is called from the legacy client.ts and doesn't pass in
 * anything to support translations.
 */
export function getErrorMessage(error: ErrorResponse) {
  let errorMessage = error?.response?.data?.message || '';

  if (errorMessage && error?.response?.data?.errors?.length > 0) {
    //For simplicity we're just using the first error here.
    errorMessage +=
      typeof error.response.data.errors[0] === 'string'
        ? `: ${error.response.data.errors[0]}`
        : typeof error.response.data.errors[0]?.message === 'string'
        ? `: ${error.response.data.errors[0].message}`
        : '';
  }

  //If above doesn't work, we fallback to behaviour that was previously in the
  //handleError function in client.ts for backwards compatibility reasons,
  //but we may want to revisit this once error handling is standardised.
  return errorMessage || error?.response?.data?.errorMessage || i18next.t('common:errors.unknown');
}

/*
 * @deprecated - Use React Query instead - see https://bit.ly/3olCH4J for more
 * details.
 */
export function getError(error: ErrorResponse) {
  let err: Error;
  const status = error?.response?.status;
  if (status === 403) {
    err = new Error(i18next.t('common:errors.insufficientPermissions'));
    //TODO Error does not have a status code property. Consider returning ErrorResponse instead
    err.name = '403';
    return err;
  }
  return new Error(getErrorMessage(error));
}
